import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "my-2 py-2 px-3" }
const _hoisted_2 = { class: "text-l font-bold" }

import  SousCategorie from "@/components/Company/SousCategorie.vue"


  
export default /*#__PURE__*/_defineComponent({
  __name: 'Categories',
  props: {
    subitems:Object,
    categorie:String
  },
  setup(__props) {

const props = __props;

  


 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(__props.categorie), 1),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.subitems, (it) => {
          return (_openBlock(), _createBlock(SousCategorie, {
            key: it.eventTypeId,
            description: it.description,
            price: it.price,
            duration: it.duration,
            eventTypeId: it.eventTypeId
          }, null, 8, ["description", "price", "duration", "eventTypeId"]))
        }), 128))
      ])
    ])
  ]))
}
}

})